import { Component } from "react";
import { Card, Container, Spinner } from "react-bootstrap";
import { getRequestByAuth } from "../../../../function/helper";

export default class DiscountCodePage extends Component {
  state = {
    users: [],
    loading: true,
  };

  async getData() {
    const datas = await getRequestByAuth(`/discount/v1/customer/show`);

    if (datas) {
      this.setState({
        users: datas.data,
        loading: false,
      });
    }
  }

  componentDidMount() {
    this.getData();
  }

  render() {
    const table = (
      <div>
        {this.state.users.length ? (
          <div>
            {this.state.users.map((code, index) => (
              <Card
                className="p-4 m-2 fw-bold"
                style={{ backgroundColor: "#EFE1FC" }}
                key={index}
              >
                <p>
                  {" "}
                  تخفیف {code.title} به ارزش {code.amount} {code.type} هدیه
                  آواکس برای شما کاربر گرامی فعال گردیده است.{" "}
                </p>
                <p>
                  کد تخفیف :{" "}
                  <span className="h4" style={{ color: "#F94309" }}>
                    {" "}
                    {code.code}{" "}
                  </span>
                </p>
              </Card>
            ))}
          </div>
        ) : (
          <Card
            className="p-4 m-2 fw-bold text-center"
            style={{ backgroundColor: "#FF713B", color: "#5702A6" }}
          >
            <div>در حال حاضر کد تخفیفی برای شما فعال نیست </div>
          </Card>
        )}
      </div>
    );

    return (
      <Container>
        <h4 className="text-secondary">کد تخفیف</h4>
        <hr />
        <Card className="tableOption w-100">
          {this.state.loading === true ? (
            <div className="text-center m-5">
              <Spinner />
            </div>
          ) : (
            table
          )}
        </Card>
      </Container>
    );
  }
}
